import React, { useEffect, useState } from 'react'

import DefaultEntityConsult from 'components/form/DefaultEntityConsult'

import { fetchArray } from 'entity';
import Cliente from 'entity/Cliente';
import Implemento from 'entity/Implemento'

import { usePerfil } from 'useAuth';

export default function ImplementoConsulta() {
    const [uidClientes, setUidClientes] = useState(null)
    const perfil = usePerfil()
    let tipoPerfil = 'cliente'

    if (perfil) {
        if (perfil.grupoPermissao) {
            if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                tipoPerfil = 'admin'
            }
            if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                tipoPerfil = 'tecnico'
            }
            if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                tipoPerfil = 'lider'
            }
        }
    }

    useEffect(() => {
        const busca = async () => {
            console.log('busca clientes')

            let uidClientesPermitidos = [];

            if (tipoPerfil === 'lider') {
                if (perfil.clientesPermitidos && Array.isArray(perfil.clientesPermitidos) && perfil.clientesPermitidos.length > 0) {
                    uidClientesPermitidos = perfil.clientesPermitidos.map(c => c.uid);
                }
            } else { // para técnico
                let query = Cliente.collection.where('perfisAutorizado.' + perfil.uid, '==', true);
                const result = await fetchArray(query.get());
                uidClientesPermitidos = result.map(c => c.uid);
            }

            setUidClientes(uidClientesPermitidos);
        }

        if (perfil && tipoPerfil !== 'admin') {
            busca()
        }

        return () => { }
    }, [perfil, tipoPerfil])

    const extraQuery = (col) => {

        if (perfil) {
            console.log('uidClientes', uidClientes)
            if (uidClientes) {
                if (uidClientes.length) {
                    if (uidClientes.length <= 10) {
                        col = col.where('cliente.uid', 'in', uidClientes);
                    }
                }
            } else {
                if (perfil && tipoPerfil !== 'admin') {

                    col = col.where('uid', '==', '');
                }

            }
        } else {
            col = col.where('uid', '==', '');
        }

        return col;
    }



    return (
        <DefaultEntityConsult
            EntityClass={Implemento}
            extraQuery={extraQuery}
            titulo="Implementos"
            routeForm="_implemento"
            showEdit={true}
            showDelete={true}
        />
    )
}
